import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { 
  Box, 
  Chip, 
  CircularProgress,  
  IconButton,  
  Table, 
  TableBody, 
  TableCell, 
  TableFooter, 
  TableHead, 
  TablePagination, 
  TableRow, 
  TableSortLabel, 
  Tooltip, 
  Typography 
} from '@mui/material';

import TablePaginationActions from '../../../../../components/utils/TablePaginationActions';
import useTablePaginationInit from '../../../../../components/hooks/useTablePaginationInit';
import TableTimeStamps from '../../../../../components/utils/TableTimeStamps';
import Copyable from '../../../../../components/utils/Copyable';
import TopBar from '../../../../../components/utils/TopBar';
import NA from '../../../../../components/utils/NA';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import { 
  GetOperationsBIZaccountingTPIQBD 
} from '../../../../../redux/actions/business/accountingTPI/quickbooksDesktop/operationsActions';

import ConfirmationModal from '../../../../../components/modals/ConfirmationModal';
import CodeViewModal from '../../../../../components/modals/CodeViewModal';
import OperationsQueueModal from './OperationsQueueModal';

import global from "../../../../../global.scss";

const OperationsQueuePage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const state = useSelector(state => state["business.accounting-tpi.qbd"]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState(null);
  const [sortDirection, setSortDirection] = useState("desc");
  const [statusFilter, setStatusFilter] = useState("");
  const [codeViewModalOpen, setCodeViewModalOpen] = useState(false);
  const [operationsQueueModalOpen, setOperationsQueueModalOpen] = useState(false);
  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [modalTitle, setModalTitle] = useState("");
  const [update, setUpdate] = useState(null);

  const [operationsQueueList, setOperationsQueueList] = useState([]);
  const [operationsQueueTotal, setOperationsQueueTotal] = useState(0);

  // eslint-disable-next-line no-unused-vars
  const [deleteId, setDeleteId] = useState(null);

  const [
    page, 
    rowsPerPage, 
    handleChangePage, 
    handleChangeRowsPerPage
  ] = useTablePaginationInit();

  const tableHeadingsList = [
    {
      label: "Id",
      sort: "id",
    },
    {
      label: "Operation",
      sort: "operation",
    },
    {
      label: "Data",
      sort: "data",
    },
    {
      label: "Status",
      sort: "status",
    },
    {
      label: "Company Id",
      sort: "company_id",
    },
    {
      label: "Ticket Id",
      sort: "processing_ticket_id"
    },
    {
      label: "Request XML",
      sort: "qb_request_xml"
    },
    {
      label: "Response XML | JSON",
      sort: "qb_response"
    },
    {
      label: "Error XML | JSON",
      sort: "qb_error"
    },
    {
      label: "Time stamps",
      sort: "createdAt",
    },
    {
      label: "",
      sort: null,
    }
  ];

  const handleSort = (value) => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    setSort(value);
  };

  useEffect(() => {
    handleGetOperationsQueue();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, search, sort, sortDirection, statusFilter]);

  useEffect(() => {
    try {
      formatOperationsQueueList(state.operationsList.records || []);
      setOperationsQueueTotal(state.operationsList.total || 0);
    } catch (err) {}
  }, [state]);

  useEffect(() => {
    let pathnameArr = location.pathname.split("/")
    let pageRoute = pathnameArr.slice(pathnameArr.length-1, pathnameArr.length)[0]

    console.log(pageRoute)

    if(pageRoute === "failed-operations"){
      setStatusFilter("failed");
    } else {
      setStatusFilter("");
    }
  }, [location]);

  const formatOperationsQueueList = (list) => {
    setOperationsQueueList(list);
  };

  async function handleGetOperationsQueue(){
    let query = ""
    if(search) query += `&search=${search}`;
    if(sort) query += `&field=${sort}`;
    if(sortDirection) query += `&order=${sortDirection}`;
    if(statusFilter) query += `&status=${statusFilter}`;
    dispatch(GetOperationsBIZaccountingTPIQBD(page+1, rowsPerPage, query, setLoading));
  };


  const handleDelete = () => {
    setDeleteConfirmationModalOpen(false);
    // dispatch(DeleteServiceBIZsubs(deleteId, setDeleting)).then(() => {
    //   handleGetServices().then(() => {
    //     setDeleteId(null);
    //   })
    // });
  }


  return (
    <Box>

      <OperationsQueueModal
        open={operationsQueueModalOpen}
        setOpen={setOperationsQueueModalOpen}
        title={modalTitle}
        update={update}
        handleGet={handleGetOperationsQueue}
        />

      <ConfirmationModal 
        open={deleteConfirmationModalOpen}
        setOpen={setDeleteConfirmationModalOpen}
        title={"Delete " + modalTitle}
        onCancel={() => setDeleteId(null)}
        onConfirm={handleDelete}
        />

      <CodeViewModal
        open={codeViewModalOpen}
        setOpen={setCodeViewModalOpen}
        title={modalTitle}
        language={update?.language}
        content={update?.content} 
        />

      <TopBar
        title={"Operations Queue"}
        search={search}
        onSearchChange={(e) => {
          setSearch(e.target.value);
        }}
        button1Text="Add Operation"
        button1OnClick={() => {}}
        />
      
      <Box 
        className="flexCenterSBRow" 
        gap="15px"
        mb={"10px"}>
        <Box  
          className="flexCenter_Row"
          gap="15px">
          <Chip 
            color={statusFilter === "" ? 'info' : 'default'}
            label="All"
            onClick={() => {
              setStatusFilter("");
            }}
            />
          <Chip 
            color={statusFilter === "completed" ? 'success' : 'default'}
            label="Success"
            onClick={() => {
              setStatusFilter("completed")
            }}
            />
          <Chip 
            color={statusFilter === "pending" ? 'warning' : 'default'}
            label="Pending"
            onClick={() => {
              setStatusFilter("pending");
            }}
            />
          <Chip 
            color={statusFilter === "processing" ? 'warning' : 'default'}
            label="Processing"
            onClick={() => {
              setStatusFilter("processing");
            }}
            />
          <Chip 
            color={statusFilter === "failed" ? 'error' : 'default'}
            label="Failed"
            onClick={() => {
              setStatusFilter("failed");
            }}
            />
        </Box>
      </Box>

      {
        loading
        ?
        <Box height={"300px"} className="flexCenterCenterRow">
          <CircularProgress />
        </Box>
        :
          operationsQueueList.length === 0
          ?
          <Box height={"300px"} className="flexCenterCenterRow">
            <Typography>No operations found</Typography>
          </Box>
          :
          <Table className="block">
            <TableHead>
              <TableRow>
                {
                  tableHeadingsList.map((heading, headingIndex) => (
                    heading.sort === null
                    ?
                    <TableCell
                      key={headingIndex}>{heading.label}</TableCell>
                    :
                    <TableCell
                      key={headingIndex}>
                      <TableSortLabel
                        active={sort === heading.sort ? true : false}
                        direction={sortDirection}
                        onClick={() => {
                          handleSort(heading.sort);
                        }}
                      >
                        {heading.label}
                      </TableSortLabel>
                    </TableCell>
                  ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {
                operationsQueueList.map((row, index) => (
                  <TableRow 
                    key={index}>
                    <TableCell>
                      <Typography
                        variant='caption'
                        color={"grey"}>
                        {row.id || <NA />}
                      </Typography>
                    </TableCell>
                    <TableCell>{row.operation || <NA />}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => {
                          setUpdate({
                            language: "json",
                            content: JSON.stringify(row.data)
                          });
                          setCodeViewModalOpen(!codeViewModalOpen);
                        }}>
                        <VisibilityOutlinedIcon 
                          color={row.data ? 'primary' : 'disabled'} />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <Chip
                        size='small'
                        color={row.status === "completed" ? 'success' : row.status === "pending" ? 'warning' : 'error'}
                        label={row.status || <NA />}>
                      </Chip>
                    </TableCell>
                    <TableCell>
                      <Box>
                        <Typography
                          variant='caption'>
                          <Copyable>
                            {row.company_id || <NA />}
                          </Copyable>
                        </Typography>
                      </Box>
                      <Typography
                        variant='sm_caption'
                        color={"grey"}>
                        <Tooltip
                          title={"EmployeeId"}>
                          <Box>
                            <Copyable>
                              {row.employee_id || <NA />}
                            </Copyable>
                          </Box>
                        </Tooltip>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant='sm_caption'
                        color={"grey"}>
                        <Copyable>
                          {row.processing_ticket_id || <NA />}
                        </Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => {
                          setUpdate({
                            language: "html",
                            content: row.qb_request_xml
                          });
                          setCodeViewModalOpen(!codeViewModalOpen);
                        }}>
                        <VisibilityOutlinedIcon 
                          color={row.qb_request_xml ? 'primary' : 'disabled'} />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => {
                          setUpdate({
                            language: "html",
                            content: row.qb_response_xml
                          });
                          setCodeViewModalOpen(!codeViewModalOpen);
                        }}>
                        <VisibilityOutlinedIcon 
                          color={row.qb_response_xml ? 'primary' : 'disabled'} />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          setUpdate({
                            language: "json",
                            content: JSON.stringify(JSON.parse(row.qb_response))
                          });
                          setCodeViewModalOpen(!codeViewModalOpen);
                        }}>
                        <VisibilityOutlinedIcon 
                          color={row.qb_response ? 'primary' : 'disabled'} />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => {
                          setUpdate({
                            language: "xml",
                            content: JSON.stringify(row.qb_error_xml)
                          });
                          setCodeViewModalOpen(!codeViewModalOpen);
                        }}>
                        <VisibilityOutlinedIcon 
                          color={row.qb_error_xml ? 'primary' : 'disabled'} />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          setUpdate({
                            language: "json",
                            content: JSON.stringify(JSON.parse(row.qb_error))
                          });
                          setCodeViewModalOpen(!codeViewModalOpen);
                        }}>
                        <VisibilityOutlinedIcon 
                          color={row.qb_error ? 'primary' : 'disabled'} />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <TableTimeStamps
                        createdAt={row.createdAt}
                        updatedAt={row.updatedAt}
                        />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={(e) => {
                         
                        }}>
                        <MoreVertIcon sx={{ color: global['secondary_light']}}/>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  sx={{ borderBottom: 0 }}
                  rowsPerPageOptions={[5, 10, 25, 50, 100]} 
                  colSpan={10}
                  count={operationsQueueTotal }
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      'aria-label': 'rows per page'
                    },
                    native: true
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                  />
              </TableRow>
            </TableFooter>
          </Table>
      }
    </Box>
  )
}

export default OperationsQueuePage;